import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { BASE_URL, AUTH } from "../../../config/axios";
import { AddwithWhiteCircle, UpdatePencil } from "../../AllSvg";
import { toast } from "react-toastify";
import Select, { components } from "react-select";
import {
  CSSforMulti,
  CSSforMulti100Width,
  CSSForSelect,
  CSSForSelect15VW,
  formatCurrencyIndian,
} from "../../CustomFunctions";
import SectionFilter from "./SectionFilter";
import { getDeductionBase, DEFAULT_DEDUCTION_BASIS } from "../paymentUtils";

const Option = (props) => (
  <components.Option {...props}>
    <label title="Star" class="star">
      <input
        id="star-checkbox"
        checked={props.isSelected}
        onChange={() => null}
        className="checkbox"
        type="checkbox"
      />
      <div className="svg-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-outline"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-filled"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100"
          width="100"
          className="svg-celebrate"
        >
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
        </svg>
      </div>
    </label>
    {props.label}
  </components.Option>
);

const MenuList = (props) => {
  const { options, selectProps } = props;

  const filteredOptions = options.filter(
    (opt) => opt.label.toLowerCase() !== "other",
  );

  const selectedValues = selectProps.value?.map((i) => i.value) || [];
  const filteredValues = filteredOptions.map((i) => i.value);

  const isAllSelected = filteredValues.every((val) =>
    selectedValues.includes(val),
  );

  const handleToggle = () => {
    if (isAllSelected) {
      const preserveOther =
        selectProps.value?.filter((i) => i.label.toLowerCase() === "other") ||
        [];
      selectProps.onChange(preserveOther);
    } else {
      const preserveOther =
        selectProps.value?.filter((i) => i.label.toLowerCase() === "other") ||
        [];
      selectProps.onChange([...filteredOptions, ...preserveOther]);
    }
  };

  return (
    <components.MenuList {...props}>
      <button
        onClick={handleToggle}
        style={{
          width: "100%",
          padding: "6px 0",
          cursor: "pointer",
          fontWeight: "600",
          borderBottom: "1px solid #e3e3e3",
          background: "white",
        }}
      >
        {isAllSelected ? "Unselect All" : "Select All"}
      </button>

      {props.children}
    </components.MenuList>
  );
};

const AddProjectDetails = ({
  getProject,
  project,
  ProjectDetails,
  usedFor,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [subCompany, setSubCompany] = useState([]);
  const [CostType, setCostType] = useState(null);

  const [croreInput, setCroreInput] = useState("");
  const [lakhInput, setLakhInput] = useState("");
  const [thousandInput, setThousandInput] = useState("");

  const [formData, setFormData] = useState({
    pr_code: "",
    project_name: "",
    project_shortname: "",
    department: "",
    worktype: "",
    section_name: "",
    section_cost: "",
    length: "",
    division: "",
    loa_date: null,
    completion_date: null,
    location: "",
    project_details: "null",
    sub_consultant: "null",
    workstat: [],
    workstages: [],
  });

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setFormData({
      pr_code: "",
      project_name: "",
      department: "",
      worktype: "",
      section_cost: "",
      loa_date: null,
      completion_date: null,
      location: "",
      project_details: "null",
      sub_consultant: "null",
      workstat: [],
      workstages: [],
    });

    setCostType("null");
    setCroreInput("");
    setLakhInput("");
    setThousandInput("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[name];
      return updated;
    });
  };
  const [projectList, setProjectList] = useState([]);
  const [subConsultantList, setSubConsultantList] = useState([]);

  const validateform = () => {
    const newErrors = {};
    const requiredFields = [
      "workstages",
      "project_details",
      "section_name",
      "length",
      "location",
      "section_cost",
    ];

    requiredFields.forEach((field) => {
      const value = formData[field];

      if (
        value === null ||
        value === undefined ||
        value === "null" ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0)
      ) {
        newErrors[field] = "This field is required!";
      }
    });

    // ✅ Workstage Percentage Validation
    const selectedProject = ProjectDetails.find(
      (p) => p.id === formData.project_details
    );
    if (selectedProject && formData.section_cost) {
      const projectPost = parseFloat(selectedProject.project_post || 0);
      const existingSectionsCost = project
        .filter((s) => s.project_details === formData.project_details)
        .reduce((sum, s) => sum + parseFloat(s.section_cost || 0), 0);
      const newSectionCost = parseFloat(formData.section_cost || 0);
      const totalAfterAdd = existingSectionsCost + newSectionCost;

      if (newSectionCost > projectPost) {
        newErrors.section_cost = `Section cost (₹${formatCurrencyIndian(newSectionCost)}) cannot exceed total project cost (₹${formatCurrencyIndian(projectPost)})`;
      } else if (totalAfterAdd > projectPost) {
        const remaining = projectPost - existingSectionsCost;
        newErrors.section_cost = `Total sections cost would exceed project cost. Max allowed for this section: ₹${formatCurrencyIndian(remaining)}`;
      }
    }

    // ── Workstage Percentage Validation ──
    if (formData.workstat?.length > 0) {
      let total = 0;
      formData.workstat.forEach((stage, index) => {
        const percentage = Number(stage.percentage);
        if (!stage.percentage && stage.percentage !== 0) {
          newErrors[`percentage_${index}`] = "Percentage is required!";
        } else {
          total += percentage;
        }
      });
      if (total !== 100) {
        newErrors.totalPercentage = "Total WorkStage Percentage must be exactly 100%";
      }
    }

    if (CostType === "null") {
      newErrors["CostType"] = "This field is required!";
    }
    if (CostType === "crore_lakh_thousand") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "crore_lakh") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "lakh_thousand") {
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
    } else if (CostType === "crore") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
    } else if (CostType === "lakh") {
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "thousand") {
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
    }

    if (formData.loa_date && formData.completion_date) {
      const loa = new Date(formData.loa_date);
      const completion = new Date(formData.completion_date);
      const maxDays = Math.round((completion - loa) / (1000 * 60 * 60 * 24));

      formData.workstat.forEach((stage, index) => {
        const days = stage.duration_days;
        if (days === undefined || days === null || days === "") {
          newErrors[`duration_${index}`] = "Duration (days) is required!";
        } else if (Number(days) < 0 || Number(days) > maxDays) {
          newErrors[`duration_${index}`] = `Must be between 0 and ${maxDays} days`;
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [projectexist, setProjectExist] = useState(false);

  useEffect(() => {
    if (project?.length > 0) {
      const existedproject = project.filter(
        (i) => i.section_name === formData.section_name,
      );
      if (existedproject.length > 0) {
        setProjectExist(true);
      } else {
        setProjectExist(false);
      }
    }
  }, [project, formData.section_name]);

  // useEffect(() => {
  //   if (projectexist === true) {
  //     toast.warn(`This Section ${formData.section_name} for this project`);
  //   }
  // });

  useEffect(() => {
    const Data = ProjectDetails.find((i) => i.id === formData.project_details);

    setFormData((prev) => ({
      ...prev,
      pr_code: Data?.pr_code,
      project_name: Data?.project_name,
      division: Data?.division_name,
    }));
  }, [formData.project_details, ProjectDetails]);

  const fetchSubcompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/division/`);
      setSubCompany(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch sub-companies.");
    }
  };

  const fetchProject = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/projectdetails/`);
      setProjectList(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch Data.");
    }
  };
  const fetchSuconsult = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subconsultant/`);
      setSubConsultantList(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch Data.");
    }
  };

  useEffect(() => {
    fetchSubcompany();
    fetchProject();
    fetchSuconsult();
  }, []);

  useEffect(() => {
    if (formData.project_details !== "null") {
      const projectListData = ProjectDetails.find(
        (i) => i.id === formData.project_details,
      );

      const matchedWorkStat =
        projectListData?.workstages_details?.filter((item) =>
          formData.workstages.includes(item.id),
        ) || [];

      setFormData((prev) => ({
        ...prev,
        sub_consultant: projectListData?.sector,
      }));

      setFormData((prev) => {
        const existing = prev.workstat || [];
        let updated = [...existing];

        matchedWorkStat.forEach((item) => {
          if (!updated.some((w) => w.id === item.id)) {
            updated.push(item);
          }
        });

        updated = updated.filter((item) =>
          formData.workstages.includes(item.id),
        );

        return { ...prev, workstat: updated };
      });
    }
  }, [formData.workstages, formData.project_details]);

  const [filterProjetData, setFiterProjectdata] = useState([]);

  useEffect(() => {
    const projectData = (ProjectDetails || []).filter(
      (item) => item.id === formData.project_details,
    );
    const workStagesData = projectData.map((i) => i.workstages_details);
    setFiterProjectdata(workStagesData.flat());
  }, [formData.project_details, ProjectDetails]);

  const WorkStatOption = filterProjetData
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({
      value: i.id,
      label: i.name,
    }));

  const [totalLength, setTotalLength] = useState(0);
  const [totalLengthError, setTotalLengthError] = useState(false);
  const [totalProjectLength, setTotalProjectLength] = useState(0);
  const [totalProjectost, setTotalProjectost] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [totalCostError, setTotalCostError] = useState(false);

  useEffect(() => {
    const data = project.filter(
      (i) => i.project_details === formData.project_details,
    );
    const total_length_sum = data.reduce(
      (sum, item) => sum + Number(item.length),
      0,
    );
    const total_cost = data.reduce(
      (sum, item) => sum + Number(item.section_cost),
      0,
    );
    const filterproject = ProjectDetails.find(
      (i) => i.id === formData.project_details,
    );

    setTotalProjectLength(filterproject?.total_length - total_length_sum || 0);
    setTotalProjectost(filterproject?.project_post - total_cost || 0);
    setTotalLength(total_length_sum);
    setTotalCost(total_cost);

    // ── Length check ──
    const total_length = total_length_sum + Number(formData.length);
    if (filterproject?.total_length && total_length > filterproject.total_length) {
      setTotalLengthError(true);
    } else {
      setTotalLengthError(false);
    }

    // ── Cost check ──
    const total_cost_check = total_cost + Number(formData.section_cost);
    if (filterproject?.project_post && total_cost_check > filterproject.project_post) {
      setTotalCostError(true);
    } else {
      setTotalCostError(false);
    }

  }, [
    ProjectDetails,
    project,
    formData.length,
    formData.section_cost,
    formData.project_details,
  ]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (projectexist === true) {
      toast.warn(
        `This Section  ${formData.section_name} already exists for this project`,
      );
      return;
    }
    if (totalLengthError === true) {
      toast.warn(
        `The total length should be equal to or less than ${totalProjectLength}.`,
      );
      return;
    }
    if (totalCostError === true) {
      toast.warn(
        `The total cost should be equal to or less than ${totalProjectost}.`,
      );
      return;
    }
    if (validateform()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      const updatedFormData = formData.workstat.map((i) => ({
        ...i,
        paymentData: {
          billingClaimedPercent: 0,
          billingReceivedPercent: 0,
          tdsPercent: 0,
          retentionPercent: 0,
          otherDeductionPercent: 0,
          remarks: "",
        },
      }));

      const payload = {
        ...formData,
        workstat: updatedFormData,
      };

      try {
        const res = await axios.post(`${BASE_URL}/dpr/project/`, payload, AUTH());

        if (res.status === 201 || res.status === 200) {
          toast.success("Section added successfully!");
          handleClose();
          getProject();
        }
      } catch (err) {
        console.error("Error adding project:", err);
        if (err.response?.data) {
          toast.error(
            `Failed to add project: ${JSON.stringify(err.response.data)}`,
          );
        } else {
          toast.error("Failed to add project");
        }
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const handlePercentageChange = (index, value) => {
    const numValue = Number(value) || 0;
    const sectionCost = Number(formData.section_cost) || 0;

    // Calculate total before updating
    const total = formData.workstat.reduce((sum, item, i) => {
      if (i === index) return sum + numValue;
      return sum + (Number(item.percentage) || 0);
    }, 0);

    if (total > 100) {
      setErrors({
        ...errors,
        totalPercentage: "Total percentage cannot exceed 100%",
      });
      return;
    }

    let newErrors = { ...errors };
    delete newErrors.totalPercentage;
    setErrors(newErrors);

    const updated = [...formData.workstat];

    updated[index].percentage = numValue;

    // ✅ AUTO CALCULATE COST
    updated[index].cost = ((sectionCost * numValue) / 100).toFixed(2);

    setFormData((prev) => ({
      ...prev,
      workstat: updated,
    }));
  };

  const handleDurationChange = (index, value) => {
    const numValue = Number(value) || 0;
    const updated = [...formData.workstat];
    updated[index].duration_days = numValue;
    setFormData((prev) => ({ ...prev, workstat: updated }));

    if (formData.loa_date && formData.completion_date) {
      const loa = new Date(formData.loa_date);
      const completion = new Date(formData.completion_date);
      const maxDays = Math.round((completion - loa) / (1000 * 60 * 60 * 24));

      setErrors((prev) => {
        const n = { ...prev };
        if (numValue < 0 || numValue > maxDays) {
          n[`duration_${index}`] = `Must be between 0 and ${maxDays} days (LOA–Completion window)`;
        } else {
          delete n[`duration_${index}`];
        }
        return n;
      });
    }
  };

  useEffect(() => {
    const sectionCost = Number(formData.section_cost) || 0;

    const updatedWorkstat = formData.workstat.map((stage) => {
      const percentage = Number(stage.percentage) || 0;

      return {
        ...stage,
        cost: ((sectionCost * percentage) / 100).toFixed(2),
      };
    });

    setFormData((prev) => ({
      ...prev,
      workstat: updatedWorkstat,
    }));
  }, [formData.section_cost]);

  const costTypeList = [
    { value: "crore", label: "In Crore" },
    { value: "lakh", label: "In Lakh" },
    { value: "thousand", label: "In Thousand" },
    { value: "crore_lakh", label: "In Crore & Lakh" },
    { value: "lakh_thousand", label: "In Lakh & Thousand" },
    { value: "crore_lakh_thousand", label: "In Crore, Lakh & Thousand" },
  ];

  const costTypesOptions = costTypeList
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((i) => ({
      value: i.value,
      label: i.label,
    }));

  const handleCostTypeChange = (selectedOption) => {
    if (!selectedOption) {
      setCostType("null");
    } else {
      setCostType(selectedOption.value);
    }
  };

  const handleCroreInputChange = (e) => {
    const value = e.target.value;

    if (/^\d{0,3}$/.test(value)) {
      setCroreInput(value);
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.croreInput;
        return updated;
      });
    }
  };

  const handleLakhInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,2}$/.test(value)) {
      setLakhInput(value);
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.lakhInput;
        return updated;
      });
    }
  };

  const handleThousandInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,5}$/.test(value)) {
      setThousandInput(value);
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.thousandInput;
        return updated;
      });
    }
  };

  useEffect(() => {
  setCroreInput("");
  setLakhInput("");
  setThousandInput("");

  // Section forms: only reset the cost inputs. Do NOT put project_post /
  // basic_value / total_amount on the section; they'd be sent with the payload.
}, [CostType]);

  useEffect(() => {
    if (
      CostType === "crore_lakh_thousand" &&
      croreInput !== "" &&
      lakhInput !== "" &&
      thousandInput !== ""
    ) {
      const totalVal = croreInput + lakhInput + thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (
      CostType === "crore_lakh" &&
      croreInput !== "" &&
      lakhInput !== ""
    ) {
      const totalVal = croreInput + lakhInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (
      CostType === "lakh_thousand" &&
      lakhInput !== "" &&
      thousandInput !== ""
    ) {
      const totalVal = lakhInput + thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "thousand" && thousandInput !== "") {
      const totalVal = thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "lakh" && lakhInput !== "") {
      const totalVal = lakhInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "crore" && croreInput !== "") {
      const totalVal = croreInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    }
  }, [CostType, croreInput, lakhInput, thousandInput]);
  return (
    <>
      <button
        title="Add Section Details"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle />
        {usedFor === "Railway"
          ? "Railway Section"
          : usedFor === "Highway"
            ? "Highway Section"
            : "Section Details"}
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave-document"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>
            Add{" "}
            {usedFor === "Railway"
              ? "Railway Section"
              : usedFor === "Highway"
                ? "Highway Section"
                : "Section Details"}{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            <div className="form-flex-wrap">
              <div className="flex-column ">
                <label className="form-labels">
                  Select Project <span className="required">*</span>
                </label>

                {!ProjectDetails || ProjectDetails.length === 0 ? (
                  <div className="form-loader">
                    <div
                      className="bar-loader"
                      style={{ width: "46.5%" }}
                    ></div>
                  </div>
                ) : (
                  <>
                    <select
                      id="project_details"
                      name="project_details"
                      value={formData.project_details}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.project_details ? "error" : ""}`}
                    >
                      <option value="">Select Project</option>
                      {ProjectDetails?.sort((a, b) =>
                        a?.pr_code?.localeCompare(b.pr_code, "en", {
                          ignorePunctuation: true,
                        }),
                      ).map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.pr_code}
                        </option>
                      ))}
                    </select>

                    {errors.project_details && (
                      <span className="error-message font-size-text">
                        {errors.project_details}
                      </span>
                    )}
                  </>
                )}
              </div>
              <div title="Project name" className="flex-column">
                <label
                  htmlFor="project_name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Project Name<span className="required">(Read-Only)</span>
                </label>
                <textarea
                  type="text"
                  id="project_name"
                  name="project_name"
                  placeholder="Project Name"
                  onChange={handleInputChange}
                  value={formData.project_name}
                  className={`form-input form-input-textarea  ${errors.project_name ? "input-error" : ""}`}
                  readOnly
                />
                {errors.project_name && (
                  <span className="error-message font-size-text">
                    {errors.project_name}
                  </span>
                )}
              </div>

              <div title="Section Name" className="flex-column">
                <label
                  htmlFor="section_name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Section Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="section_name"
                  name="section_name"
                  placeholder="Enter Section Name"
                  onChange={handleInputChange}
                  value={formData.section_name}
                  className={`form-input ${errors.section_name ? "input-error" : ""}`}
                />
                {errors.section_name && (
                  <span className="error-message font-size-text">
                    {errors.section_name}
                  </span>
                )}
              </div>
              <div
                className="flex-row justify-between "
                style={{ width: "35vw" }}
              >
                <div title="Length" className="flex-column">
                  <label
                    htmlFor="length"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Length(in KM.)<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    id="length"
                    name="length"
                    placeholder="Enter Length"
                    onChange={handleInputChange}
                    value={formData.length}
                    className={`form-input width-15vw ${errors.length ? "input-error" : ""}`}
                  />
                  {errors.length && (
                    <span className="error-message font-size-text">
                      {errors.length}
                    </span>
                  )}
                </div>
                <div title="Location" className="flex-column">
                  <label
                    htmlFor="location"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Location<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    placeholder="Enter Location"
                    onChange={handleInputChange}
                    value={formData.location}
                    style={{ width: "15vw" }}
                    className={`form-input ${errors.location ? "input-error" : ""}`}
                  />
                  {errors.location && (
                    <span className="error-message font-size-text">
                      {errors.location}
                    </span>
                  )}
                </div>
              </div>
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Cost Type <span className="required">*</span>
                  </label>

                  <>
                    <Select
                      options={costTypesOptions}
                      onChange={handleCostTypeChange}
                      value={
                        CostType === "null" || CostType === undefined
                          ? "null"
                          : costTypesOptions.find(
                            (option) => option.value === CostType,
                          )
                      }
                      placeholder="Select Cost Type"
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "No other options"}
                      styles={
                        CostType === "null" ||
                          CostType === "lakh_thousand" ||
                          CostType === "crore_lakh"
                          ? CSSForSelect
                          : CSSForSelect15VW
                      }
                    />

                    {errors.CostType && (
                      <span className="error-message font-size-text">
                        {errors.CostType}
                      </span>
                    )}
                  </>
                </div>
                {CostType === "crore_lakh_thousand" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : CostType === "crore" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={3}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        onBlur={() => {
                          if (CostType === "crore" && croreInput) {
                            setCroreInput((prev) => {
                              if (prev.length <= 3) {
                                return prev + "0000000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : CostType === "lakh" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        value={lakhInput}
                        onBlur={() => {
                          if (CostType === "lakh" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length <= 2) {
                                return prev + "00000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : (
                  CostType === "thousand" && (
                    <>
                      <div title="Section Cost" className="flex-column">
                        <label
                          htmlFor="thousandInput"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Section Cost
                          <span className="required">(in Thousands)*</span>
                        </label>
                        <input
                          type="number"
                          maxLength={100}
                          id="thousandInput"
                          name="thousandInput"
                          placeholder="In Thousands"
                          style={{ width: "15vw" }}
                          onChange={handleThousandInputChange}
                          value={thousandInput}
                          onBlur={() => {
                            if (CostType === "thousand" && thousandInput) {
                              setThousandInput((prev) => {
                                if (prev.length <= 2) {
                                  return prev + "000"; // add 3 zeros
                                }
                                if (prev.length < 5) {
                                  return prev.padEnd(5, "0"); // pad to 5 digits
                                }
                                return prev;
                              });
                            }
                          }}
                          className={`form-input ${errors.thousandInput ? "input-error" : ""}`}
                        />
                        {errors.thousandInput && (
                          <span className="error-message font-size-text">
                            {errors.thousandInput}
                          </span>
                        )}
                      </div>
                    </>
                  )
                )}
              </div>
              {CostType === "crore_lakh" && (
                <div
                  className="flex-row justify-between"
                  style={{ width: "35vw" }}
                >
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        onBlur={() => {
                          if (CostType === "crore_lakh" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev + "00000";
                              }
                              if (prev.length <= 2) {
                                return prev + "00000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        value={lakhInput}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                  </>
                </div>
              )}

              {(CostType === "crore_lakh_thousand" ||
                CostType === "lakh_thousand") && (
                  <div
                    className="flex-row justify-between"
                    style={{ width: "35vw" }}
                  >
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        value={lakhInput}
                        onBlur={() => {
                          if (CostType === "crore_lakh_thousand" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev;
                              }

                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="thousandInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost
                        <span className="required">(in Thousands)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="thousandInput"
                        name="thousandInput"
                        placeholder="In Thousands"
                        style={{ width: "15vw" }}
                        onChange={handleThousandInputChange}
                        value={thousandInput}
                        onBlur={() => {
                          if (
                            CostType === "crore_lakh_thousand" &&
                            thousandInput
                          ) {
                            setThousandInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev + "000";
                              }
                              if (prev.length <= 2) {
                                return prev + "000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.thousandInput ? "input-error" : ""}`}
                      />
                      {errors.thousandInput && (
                        <span className="error-message font-size-text">
                          {errors.thousandInput}
                        </span>
                      )}
                    </div>
                  </div>
                )}

              <div
                title="WorkStat List"
                className="flex-column form-group-selectt"
              >
                <label
                  htmlFor="workstages"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  WorkStat List<span className="required">*</span>
                </label>
                <br />
                <Select
                  options={WorkStatOption}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option, MenuList }}
                  placeholder="Select Name"
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      workstages: selected
                        ? selected.map((item) => item.value)
                        : [],
                    }))
                  }
                  value={formData?.workstages
                    ?.map((val) =>
                      WorkStatOption.find((opt) => opt.value === val),
                    )
                    .filter(Boolean)}
                  // styles={{
                  //     control: (provided) => ({
                  //         ...provided,
                  //         width: '33.5vw',
                  //         minHeight: '50px',
                  //         borderRadius: '10px',
                  //         border: '1px solid #e3e3e3',
                  //         margin: '10px 0px 20px 0px',
                  //         color: '#4a4a4a',
                  //         backgroundColor: '#f7f8fa',
                  //         padding: '0px 10px',
                  //     }),
                  //     placeholder: (provided) => ({
                  //         ...provided,
                  //         color: '#4a4a4a',
                  //     }),
                  //     menu: (provided) => ({
                  //         ...provided,
                  //         width: '33.5vw',
                  //         borderRadius: '10px',
                  //         marginTop: '0',
                  //     }),
                  //     singleValue: (provided) => ({
                  //         ...provided,
                  //         color: '#4a4a4a',
                  //     }),
                  //     input: (provided) => ({
                  //         ...provided,
                  //         color: '#4a4a4a',
                  //     }),

                  //     option: (provided, state) => ({
                  //         ...provided,
                  //         backgroundColor: state.isSelected
                  //             ? "#cfe2ff"
                  //             : state.isFocused
                  //                 ? "#cfe2ff"
                  //                 : "white",

                  //         color: "#4a4a4a",
                  //         padding: "8px 12px",
                  //         ":active": {
                  //             backgroundColor: "#cfe2ff",
                  //         }
                  //     }),

                  // }}

                  styles={
                    CostType === "crore_lakh_thousand" ||
                      CostType === "lakh_thousand" ||
                      CostType === "crore_lakh"
                      ? CSSforMulti100Width
                      : CSSforMulti
                  }
                />

                {errors.workstages && (
                  <span className="error-message font-size-text ">
                    {errors.workstages}
                  </span>
                )}
              </div>
              {Array.isArray(formData.workstat) &&
  formData.workstat.map((stage, index) => (
    <div
      key={stage.id || index}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
        gap: "16px",
        width: "100%",
        padding: "16px",
        marginBottom: "12px",
        background: "#f5f7fa",
        border: "0.5px solid #e0e0e0",
        borderRadius: "6px",
        boxSizing: "border-box",
      }}
    >
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          WorkStage Name<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          disabled
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.name}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          InputType<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          disabled
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.workstage_inputtype}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Percentage<span className="required">*</span>
        </label>
        <input
          type="number"
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          placeholder="Enter Percentage"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") e.preventDefault();
          }}
          value={stage.percentage}
          onChange={(e) => handlePercentageChange(index, e.target.value)}
        />
        {errors[`percentage_${index}`] && (
          <span className="error-message font-size-text">{errors[`percentage_${index}`]}</span>
        )}
        {errors.totalPercentage && (
          <span className="error-message font-size-text">{errors.totalPercentage}</span>
        )}
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Cost<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="0"
          disabled
          style={{ width: "100%", boxSizing: "border-box" }}
          value={
            typeof formatCurrencyIndian === "function"
              ? formatCurrencyIndian(Number(stage.cost) || 0)
              : stage.cost
          }
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Scope<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter Scope"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.scope}
          onChange={(e) => {
            const updated = [...formData.workstat];
            updated[index].scope = e.target.value;
            setFormData((prev) => ({ ...prev, workstat: updated }));
          }}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Actual<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="0"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.actual}
          onChange={(e) => {
            const updated = [...formData.workstat];
            updated[index].actual = e.target.value;
            setFormData((prev) => ({ ...prev, workstat: updated }));
          }}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Duration (Days)<span className="required">*</span>
        </label>
        <input
          type="number"
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          placeholder="e.g. 45"
          min={0}
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") e.preventDefault();
          }}
          value={stage.duration_days ?? ""}
          onChange={(e) => handleDurationChange(index, e.target.value)}
        />
        {errors[`duration_${index}`] && (
          <span className="error-message font-size-text">{errors[`duration_${index}`]}</span>
        )}
      </div>
    </div>
  ))}
            </div>

            {/* Submit Button */}
            <div className="button-models" style={{ width: "100%" }}>
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="model-button font-weight500 model-button-submit"
              >
                Add
              </button>
            </div>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateProjectDetails = ({
  i,
  getProject,
  project,
  usedFor,
  ProjectDetails,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [subCompany, setSubCompany] = useState([]);
  const [subConsultantList, setSubConsultantList] = useState([]);
  const [CostType, setCostType] = useState(null);
  const safeProjectDetails = ProjectDetails || [];
  const safeProject = project || [];

  const [croreInput, setCroreInput] = useState("");
  const [lakhInput, setLakhInput] = useState("");
  const [thousandInput, setThousandInput] = useState("");

  const [formData, setFormData] = useState({
    pr_code: "",
    project_name: "",
    project_shortname: "",
    department: "",
    worktype: "",
    division: "",
    loa_date: null,
    section_cost: "",

    completion_date: null,
    location: "",
    section_name: "",
    length: "",
    project_details: "null",
    workstat: [],

    workstages: [],
  });

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setCostType("null");
    setCroreInput("");
    setLakhInput("");
    setThousandInput("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [projectList, setProjectList] = useState([]);

  const validateform = () => {
    const newErrors = {};

    const requiredFields = [
      "workstages",
      "project_details",
      "section_name",
      "length",
      "location",
      "section_cost",
    ];

    requiredFields.forEach((field) => {
      const value = formData[field];

      // for string values
      if (typeof value === "string" && value.trim() === "") {
        newErrors[field] = "This field is required!";
      }
      // for arrays (like workstages)
      else if (Array.isArray(value) && value.length === 0) {
        newErrors[field] = "This field is required!";
      }
      // for values that are null / undefined / "null"
      else if (value === null || value === undefined || value === "null") {
        newErrors[field] = "This field is required!";
      }
    });

    const selectedProject = safeProjectDetails.find(
      (p) => p.id === formData.project_details
    );
    if (selectedProject && formData.section_cost && CostType !== "null") {
      // ↑ only validate when user is actively changing the cost
      const projectPost = parseFloat(selectedProject.project_post || 0);
      const existingSectionsCost = safeProject
        .filter((s) => s.project_details === formData.project_details && s.id !== i.id)
        .reduce((sum, s) => sum + parseFloat(s.section_cost || 0), 0);
      const newSectionCost = parseFloat(formData.section_cost || 0);
      const totalAfterUpdate = existingSectionsCost + newSectionCost;

      if (newSectionCost > projectPost) {
        newErrors.section_cost = `Section cost (₹${formatCurrencyIndian(newSectionCost)}) cannot exceed total project cost (₹${formatCurrencyIndian(projectPost)})`;
      } else if (totalAfterUpdate > projectPost) {
        const remaining = projectPost - existingSectionsCost;
        newErrors.section_cost = `Total sections cost would exceed project cost. Max allowed: ₹${formatCurrencyIndian(remaining)}`;
      }
    }

    if (formData.workstat?.length > 0) {
      let total = 0;

      formData.workstat.forEach((stage, index) => {
        const percentage = Number(stage.percentage);

        if (!stage.percentage && stage.percentage !== 0) {
          newErrors[`percentage_${index}`] = "Percentage is required!";
        } else {
          total += percentage;
        }
      });

      if (total !== 100) {
        newErrors.totalPercentage =
          "Total WorkStage Percentage must be exactly 100%";
      }
    }

    if (CostType === "crore_lakh_thousand") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "crore_lakh") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "lakh_thousand") {
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
    } else if (CostType === "crore") {
      if (croreInput.trim() === "") {
        newErrors["croreInput"] = "This field is required!";
      }
    } else if (CostType === "lakh") {
      if (lakhInput.trim() === "") {
        newErrors["lakhInput"] = "This field is required!";
      }
    } else if (CostType === "thousand") {
      if (thousandInput.trim() === "") {
        newErrors["thousandInput"] = "This field is required!";
      }
    }
    if (formData.loa_date && formData.completion_date) {
      const loa = new Date(formData.loa_date);
      const completion = new Date(formData.completion_date);
      const maxDays = Math.round((completion - loa) / (1000 * 60 * 60 * 24));

      formData.workstat.forEach((stage, index) => {
        const days = stage.duration_days;
        if (days === undefined || days === null || days === "") {
          newErrors[`duration_${index}`] = "Duration (days) is required!";
        } else if (Number(days) < 0 || Number(days) > maxDays) {
          newErrors[`duration_${index}`] = `Must be between 0 and ${maxDays} days`;
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateform()) return;

    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const newSectionCost = parseFloat(formData.section_cost || 0);

      // Project's Basic Value / GST / Total, so each deduction is recalculated
      // on the basis chosen in the Payment modal (Basic Value / GST / Total).
      const projectCost =
        safeProjectDetails.find((p) => p.id === formData.project_details) ||
        formData.project_details_data ||
        {};
      const dedBase = (received, basis) =>
        getDeductionBase(received, basis || DEFAULT_DEDUCTION_BASIS, projectCost);

      // ── Recalculate all workstat data based on new section cost ──
      const recalculatedWorkstat = formData.workstat.map((ws) => {
        const newWsCost = parseFloat(
          ((parseFloat(ws.percentage || 0) / 100) * newSectionCost).toFixed(2)
        );

        // ── Stage type: recalculate stage_amount, completed_work, remaining_work ──
        const updatedStage = (ws.stage || []).map((st) => {
          const stPct = parseFloat(st.percentage || 0) / 100;
          const newStageAmount = parseFloat((stPct * newWsCost).toFixed(2));
          const completedPct = parseFloat(st.completed_percentage || 0) / 100;
          const newCompletedWork = parseFloat((completedPct * newStageAmount).toFixed(2));
          const newRemainingWork = parseFloat((newStageAmount - newCompletedWork).toFixed(2));

          return {
            ...st,
            stage_amount: newStageAmount.toFixed(2),
            completed_work: newCompletedWork.toFixed(2),
            remaining_work: newRemainingWork.toFixed(2),
          };
        });

        // ── Input type: recalculate normal_input cost ──
        const updatedNormalInput = (ws.normal_input || []).map((ni) => ({
          ...ni,
          cost: newWsCost.toFixed(2),
        }));

        // ── Payment: recalculate amounts using existing percentages ──
        const oldPayment = ws.paymentData || {};

        // aboutToBill depends on workstage type
        let newAboutToBill = newWsCost;
        if (ws.workstage_inputtype === "Stage") {
          newAboutToBill = updatedStage.reduce(
            (sum, st) => sum + parseFloat(st.completed_work || 0), 0
          );
        }

        const newBillingClaimedAmt = parseFloat(
          ((parseFloat(oldPayment.billingClaimedPercent || 0) / 100) * newAboutToBill).toFixed(2)
        );
        const newBillingReceivedAmt = parseFloat(
          ((parseFloat(oldPayment.billingReceivedPercent || 0) / 100) * newBillingClaimedAmt).toFixed(2)
        );
        const newTdsAmt = parseFloat(
          ((parseFloat(oldPayment.tdsPercent || 0) / 100) *
            dedBase(newBillingReceivedAmt, oldPayment.tdsBasis)).toFixed(2)
        );
        const newRetentionAmt = parseFloat(
          ((parseFloat(oldPayment.retentionPercent || 0) / 100) *
            dedBase(newBillingReceivedAmt, oldPayment.retentionBasis)).toFixed(2)
        );
        const newLabourcessAmt = parseFloat(
          ((parseFloat(oldPayment.LabourcessPercent || 0) / 100) *
            dedBase(newBillingReceivedAmt, oldPayment.LabourcessBasis)).toFixed(2)
        );
        const newOtherAmt = parseFloat(
          ((parseFloat(oldPayment.otherDeductionPercent || 0) / 100) *
            dedBase(newBillingReceivedAmt, oldPayment.otherDeductionBasis)).toFixed(2)
        );
        const newTotalDeduction = parseFloat(
          (newTdsAmt + newRetentionAmt + newLabourcessAmt + newOtherAmt).toFixed(2)
        );
        const newNetReceived = parseFloat((newBillingReceivedAmt - newTotalDeduction).toFixed(2));
        const newBalanceToClaim = parseFloat((newAboutToBill - newBillingClaimedAmt).toFixed(2));
        const newBalanceToReceive = parseFloat((newBillingClaimedAmt - newBillingReceivedAmt).toFixed(2));

        return {
          ...ws,
          cost: newWsCost.toFixed(2),
          stage: updatedStage,
          normal_input: updatedNormalInput,
          paymentData: {
            ...oldPayment,
            aboutToBillAmount: newAboutToBill,
            billingClaimedAmount: newBillingClaimedAmt,
            billingReceivedAmount: newBillingReceivedAmt,
            tdsAmount: newTdsAmt,
            retentionAmount: newRetentionAmt,
            LabourcessAmount: newLabourcessAmt,
            otherDeductionAmount: newOtherAmt,
            totalDeductionAmount: newTotalDeduction,
            netReceivedAmount: newNetReceived,
            balanceToClaimAmount: newBalanceToClaim,
            balanceToReceiveAmount: newBalanceToReceive,
            balanceAmount: newBalanceToReceive,
          },
        };
      });

      const payload = {
        ...formData,
        workstat: recalculatedWorkstat,
      };

      const res = await axios.put(
        `${BASE_URL}/dpr/project/${i.id}/`,
        payload,
        AUTH()
      );

      if (res.status === 201 || res.status === 200) {
        toast.success("Section updated successfully!");
        setShow(false);
        getProject();
      }
    } catch (err) {
      console.error("Error updating project:", err);
      if (err.response?.data) {
        toast.error(`Failed to update: ${JSON.stringify(err.response.data)}`);
      } else {
        toast.error("Failed to update project");
      }
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  useEffect(() => {
    const Data = (ProjectDetails || []).find(
      (i) => i.id === formData.project_details,
    );

    setFormData((prev) => ({
      ...prev,
      pr_code: Data?.pr_code,
      project_name: Data?.project_name,
      division: Data?.division_name,
    }));
  }, [formData.project_details, ProjectDetails]);

  const fetchSubcompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/division/`);
      setSubCompany(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch sub-companies.");
    }
  };

  const fetchProject = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/projectdetails/`);
      setProjectList(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch Data.");
    }
  };

  const fetchSuconsult = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subconsultant/`);
      setSubConsultantList(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch Data.");
    }
  };

  useEffect(() => {
    if (show === true) {
      fetchSubcompany();
      fetchProject();
      fetchSuconsult();
    }
  }, [show]);

  const subConsultantOption = subConsultantList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  console.log("formData");
  console.log(formData);

  const handleSubConsultantChange = (selectedOption) => {
    if (!selectedOption) {
      // Reset to null when cleared
      setFormData({
        ...formData,
        sub_consultant: "null",
      });
    } else {
      setFormData({
        ...formData,
        sub_consultant: selectedOption.value,
      });
    }
  };
  const [filterProjetData, setFiterProjectdata] = useState([]);

  useEffect(() => {
    const projectData = safeProjectDetails.filter(
      (item) => item.id === formData.project_details,
    );
    const workStagesData = projectData.map((i) => i.workstages_details);
    setFiterProjectdata(workStagesData.flat());
  }, [formData.project_details, safeProjectDetails]);

  const WorkStatOption = filterProjetData
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({
      value: i.id,
      label: i.name,
    }));

  useEffect(() => {
    if (formData.project_details !== "null") {
      const projectListData = safeProjectDetails.find(
        (i) => i.id === formData.project_details,
      );

      const matchedWorkStat =
        projectListData?.workstages_details?.filter((item) =>
          formData.workstages.includes(item.id),
        ) || [];

      setFormData((prev) => ({
        ...prev,
        sub_consultant: projectListData?.sector,
      }));

      setFormData((prev) => {
        const existing = prev.workstat || [];
        let updated = [...existing];

        // ADD newly selected workstages (not already present)
        matchedWorkStat.forEach((item) => {
          if (!updated.some((w) => w.id === item.id)) {
            updated.push(item);
          }
        });

        // REMOVE deselected workstages
        updated = updated.filter((item) =>
          formData.workstages.includes(item.id),
        );

        return { ...prev, workstat: updated };
      });
    }
  }, [formData.workstages, formData.project_details, ProjectDetails]);

  const handlePercentageChange = (index, value) => {
    const numValue = Number(value) || 0;
    const sectionCost = Number(formData.section_cost) || 0;

    // Calculate total before updating
    const total = formData.workstat.reduce((sum, item, i) => {
      if (i === index) return sum + numValue;
      return sum + (Number(item.percentage) || 0);
    }, 0);

    if (total > 100) {
      setErrors({
        ...errors,
        totalPercentage: "Total percentage cannot exceed 100%",
      });
      return;
    }

    let newErrors = { ...errors };
    delete newErrors.totalPercentage;
    setErrors(newErrors);

    const updated = [...formData.workstat];

    updated[index].percentage = numValue;

    // ✅ AUTO CALCULATE COST
    updated[index].cost = ((sectionCost * numValue) / 100).toFixed(2);

    setFormData((prev) => ({
      ...prev,
      workstat: updated,
    }));
  };
  const handleDurationChange = (index, value) => {
    const numValue = Number(value) || 0;
    const updated = [...formData.workstat];
    updated[index].duration_days = numValue;
    setFormData((prev) => ({ ...prev, workstat: updated }));

    if (formData.loa_date && formData.completion_date) {
      const loa = new Date(formData.loa_date);
      const completion = new Date(formData.completion_date);
      const maxDays = Math.round((completion - loa) / (1000 * 60 * 60 * 24));

      setErrors((prev) => {
        const n = { ...prev };
        if (numValue < 0 || numValue > maxDays) {
          n[`duration_${index}`] = `Must be between 0 and ${maxDays} days (LOA–Completion window)`;
        } else {
          delete n[`duration_${index}`];
        }
        return n;
      });
    }
  };
  useEffect(() => {
    const sectionCost = Number(formData.section_cost) || 0;

    const updatedWorkstat = formData.workstat.map((stage) => {
      const percentage = Number(stage.percentage) || 0;

      return {
        ...stage,
        cost: ((sectionCost * percentage) / 100).toFixed(2),
      };
    });

    setFormData((prev) => ({
      ...prev,
      workstat: updatedWorkstat,
    }));
  }, [formData.section_cost]); // runs whenever section_cost changes

  const costTypeList = [
    { value: "crore", label: "In Crore" },
    { value: "lakh", label: "In Lakh" },
    { value: "thousand", label: "In Thousand" },
    { value: "crore_lakh", label: "In Crore & Lakh" },
    { value: "lakh_thousand", label: "In Lakh & Thousand" },
    { value: "crore_lakh_thousand", label: "In Crore, Lakh & Thousand" },
  ];

  const costTypesOptions = costTypeList
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((i) => ({
      value: i.value,
      label: i.label,
    }));

  const handleCostTypeChange = (selectedOption) => {
    if (!selectedOption) {
      setCostType("null");
    } else {
      setCostType(selectedOption.value);
    }
  };

  const handleCroreInputChange = (e) => {
    const value = e.target.value;

    if (/^\d{0,3}$/.test(value)) {
      setCroreInput(value);
    }
  };

  const handleLakhInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,2}$/.test(value)) {
      setLakhInput(value);
    }
  };

  const handleThousandInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,5}$/.test(value)) {
      setThousandInput(value);
    }
  };

  useEffect(() => {
  setCroreInput("");
  setLakhInput("");
  setThousandInput("");

  // Section forms: only reset the cost inputs. Do NOT put project_post /
  // basic_value / total_amount on the section; they'd be sent with the payload.
}, [CostType]);

  useEffect(() => {
    if (
      CostType === "crore_lakh_thousand" &&
      croreInput !== "" &&
      lakhInput !== "" &&
      thousandInput !== ""
    ) {
      const totalVal = croreInput + lakhInput + thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (
      CostType === "crore_lakh" &&
      croreInput !== "" &&
      lakhInput !== ""
    ) {
      const totalVal = croreInput + lakhInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (
      CostType === "lakh_thousand" &&
      lakhInput !== "" &&
      thousandInput !== ""
    ) {
      const totalVal = lakhInput + thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "thousand" && thousandInput !== "") {
      const totalVal = thousandInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "lakh" && lakhInput !== "") {
      const totalVal = lakhInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    } else if (CostType === "crore" && croreInput !== "") {
      const totalVal = croreInput;
      setFormData((prev) => ({
        ...prev,
        section_cost: totalVal,
      }));
    }
  }, [CostType, croreInput, lakhInput, thousandInput]);

  return (
    <>
      <button
        title="Update Section Details"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave-document"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>
            Update{" "}
            {usedFor === "Railway"
              ? "Railway Section"
              : usedFor === "Highway"
                ? "Highway Section"
                : "Section Details"}{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            <div className="form-flex-wrap">
              <div className="flex-column ">
                <label className="form-labels">
                  Select Project <span className="required">*</span>
                </label>

                {safeProjectDetails.length === 0 ? (
                  <div className="form-loader">
                    <div
                      className="bar-loader"
                      style={{ width: "46.5%" }}
                    ></div>
                  </div>
                ) : (
                  <>
                    <select
                      id="project_details"
                      name="project_details"
                      value={formData.project_details}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.project_details ? "error" : ""}`}
                    >
                      <option value="">Select Project</option>
                      {safeProjectDetails
                        ?.sort((a, b) =>
                          a?.pr_code?.localeCompare(b.pr_code, "en", {
                            ignorePunctuation: true,
                          }),
                        )
                        .map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.pr_code}
                          </option>
                        ))}
                    </select>

                    {errors.project_details && (
                      <span className="error-message font-size-text">
                        {errors.project_details}
                      </span>
                    )}
                  </>
                )}
              </div>
              <div title="Project name" className="flex-column">
                <label
                  htmlFor="project_name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Project Name<span className="required">(Read-Only)</span>
                </label>
                <textarea
                  type="text"
                  id="project_name"
                  name="project_name"
                  placeholder="Project Name"
                  onChange={handleInputChange}
                  value={formData.project_name}
                  className={`form-input form-input-textarea  ${errors.project_name ? "input-error" : ""}`}
                  readOnly
                />
                {errors.project_name && (
                  <span className="error-message font-size-text">
                    {errors.project_name}
                  </span>
                )}
              </div>

              <div title="Section Name" className="flex-column">
                <label
                  htmlFor="section_name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Section Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="section_name"
                  name="section_name"
                  placeholder="Enter Section Name"
                  onChange={handleInputChange}
                  value={formData.section_name}
                  className={`form-input ${errors.section_name ? "input-error" : ""}`}
                />
                {errors.section_name && (
                  <span className="error-message font-size-text">
                    {errors.section_name}
                  </span>
                )}
              </div>
              <div
                className="flex-row justify-between "
                style={{ width: "35vw" }}
              >
                <div title="Length" className="flex-column">
                  <label
                    htmlFor="length"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Length(in KM.)<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    id="length"
                    name="length"
                    placeholder="Enter Length"
                    onChange={handleInputChange}
                    value={formData.length}
                    className={`form-input width-15vw ${errors.length ? "input-error" : ""}`}
                  />
                  {errors.length && (
                    <span className="error-message font-size-text">
                      {errors.length}
                    </span>
                  )}
                </div>
                <div title="Location" className="flex-column">
                  <label
                    htmlFor="location"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Location<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    placeholder="Enter Location"
                    onChange={handleInputChange}
                    value={formData.location}
                    style={{ width: "15vw" }}
                    className={`form-input ${errors.location ? "input-error" : ""}`}
                  />
                  {errors.location && (
                    <span className="error-message font-size-text">
                      {errors.location}
                    </span>
                  )}
                </div>
              </div>

              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                {CostType === "null" && (
                  <div title="Section Cost" className="flex-column">
                    <label
                      htmlFor="section_cost"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      Section Cost<span className="required">(Read-Only)</span>
                    </label>
                    <input
                      type="number"
                      id="section_cost"
                      name="section_cost"
                      placeholder="Enter Section Cost"
                      onChange={handleInputChange}
                      disabled
                      value={formData.section_cost}
                      className={`form-input width-15vw ${errors.section_cost ? "input-error" : ""}`}
                    />
                    {errors.section_cost && (
                      <span className="error-message font-size-text">
                        {errors.section_cost}
                      </span>
                    )}
                  </div>
                )}
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Cost Type <span className="required">*</span>
                  </label>

                  <>
                    <Select
                      options={costTypesOptions}
                      onChange={handleCostTypeChange}
                      value={
                        CostType === "null" || CostType === undefined
                          ? "null"
                          : costTypesOptions.find(
                            (option) => option.value === CostType,
                          )
                      }
                      placeholder="Select Cost Type"
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "No other options"}
                      styles={
                        CostType === "lakh_thousand" ||
                          CostType === "crore_lakh"
                          ? CSSForSelect
                          : CSSForSelect15VW
                      }
                    />

                    {errors.CostType && (
                      <span className="error-message font-size-text">
                        {errors.CostType}
                      </span>
                    )}
                  </>
                </div>
                {CostType === "crore_lakh_thousand" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : CostType === "crore" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={3}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        onBlur={() => {
                          if (CostType === "crore" && croreInput) {
                            setCroreInput((prev) => {
                              if (prev.length <= 3) {
                                return prev + "0000000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : CostType === "lakh" ? (
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        value={lakhInput}
                        onBlur={() => {
                          if (CostType === "lakh" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length <= 2) {
                                return prev + "00000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                  </>
                ) : (
                  CostType === "thousand" && (
                    <>
                      <div title="Section Cost" className="flex-column">
                        <label
                          htmlFor="thousandInput"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Section Cost
                          <span className="required">(in Thousands)*</span>
                        </label>
                        <input
                          type="number"
                          maxLength={100}
                          id="thousandInput"
                          name="thousandInput"
                          placeholder="In Thousands"
                          style={{ width: "15vw" }}
                          onChange={handleThousandInputChange}
                          value={thousandInput}
                          onBlur={() => {
                            if (CostType === "thousand" && thousandInput) {
                              setThousandInput((prev) => {
                                if (prev.length <= 2) {
                                  return prev + "000"; // add 3 zeros
                                }
                                if (prev.length < 5) {
                                  return prev.padEnd(5, "0"); // pad to 5 digits
                                }
                                return prev;
                              });
                            }
                          }}
                          className={`form-input ${errors.thousandInput ? "input-error" : ""}`}
                        />
                        {errors.thousandInput && (
                          <span className="error-message font-size-text">
                            {errors.thousandInput}
                          </span>
                        )}
                      </div>
                    </>
                  )
                )}
              </div>
              {CostType === "crore_lakh" && (
                <div
                  className="flex-row justify-between"
                  style={{ width: "35vw" }}
                >
                  <>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="croreInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Cr)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="croreInput"
                        name="croreInput"
                        placeholder="In Crores"
                        style={{ width: "15vw" }}
                        onChange={handleCroreInputChange}
                        value={croreInput}
                        className={`form-input ${errors.croreInput ? "input-error" : ""}`}
                      />
                      {errors.croreInput && (
                        <span className="error-message font-size-text">
                          {errors.croreInput}
                        </span>
                      )}
                    </div>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        onBlur={() => {
                          if (CostType === "crore_lakh" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev + "00000";
                              }
                              if (prev.length <= 2) {
                                return prev + "00000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        value={lakhInput}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                  </>
                </div>
              )}

              {(CostType === "crore_lakh_thousand" ||
                CostType === "lakh_thousand") && (
                  <div
                    className="flex-row justify-between"
                    style={{ width: "35vw" }}
                  >
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="lakhInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost<span className="required">(in Lakh)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="lakhInput"
                        name="lakhInput"
                        placeholder="In Lakhs"
                        style={{ width: "15vw" }}
                        onChange={handleLakhInputChange}
                        value={lakhInput}
                        onBlur={() => {
                          if (CostType === "crore_lakh_thousand" && lakhInput) {
                            setLakhInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev;
                              }

                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
                      />
                      {errors.lakhInput && (
                        <span className="error-message font-size-text">
                          {errors.lakhInput}
                        </span>
                      )}
                    </div>
                    <div title="Section Cost" className="flex-column">
                      <label
                        htmlFor="thousandInput"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Section Cost
                        <span className="required">(in Thousands)*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={100}
                        id="thousandInput"
                        name="thousandInput"
                        placeholder="In Thousands"
                        style={{ width: "15vw" }}
                        onChange={handleThousandInputChange}
                        value={thousandInput}
                        onBlur={() => {
                          if (
                            CostType === "crore_lakh_thousand" &&
                            thousandInput
                          ) {
                            setThousandInput((prev) => {
                              if (prev.length === 1) {
                                return "0" + prev + "000";
                              }
                              if (prev.length <= 2) {
                                return prev + "000"; // add 3 zeros
                              }
                              if (prev.length < 5) {
                                return prev.padEnd(5, "0"); // pad to 5 digits
                              }
                              return prev;
                            });
                          }
                        }}
                        className={`form-input ${errors.thousandInput ? "input-error" : ""}`}
                      />
                      {errors.thousandInput && (
                        <span className="error-message font-size-text">
                          {errors.thousandInput}
                        </span>
                      )}
                    </div>
                  </div>
                )}

              <div
                title="WorkStat List"
                className="flex-column form-group-selectt"
              >
                <label
                  htmlFor="workstages"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  WorkStat List<span className="required">*</span>
                </label>
                <br />
                <Select
                  options={WorkStatOption}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option, MenuList }}
                  placeholder="Select Name"
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      workstages: selected
                        ? selected.map((item) => item.value)
                        : [],
                    }))
                  }
                  value={formData?.workstages
                    ?.map((val) =>
                      WorkStatOption.find((opt) => opt.value === val),
                    )
                    .filter(Boolean)}
                  styles={
                    CostType === "crore_lakh_thousand" ||
                      CostType === "lakh_thousand" ||
                      CostType === "crore_lakh"
                      ? CSSforMulti100Width
                      : CSSforMulti
                  }
                />

                {errors.workstages && (
                  <span className="error-message font-size-text ">
                    {errors.workstages}
                  </span>
                )}
              </div>
              {Array.isArray(formData.workstat) &&
  formData.workstat.map((stage, index) => (
    <div
      key={stage.id || index}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
        gap: "16px",
        width: "100%",
        padding: "16px",
        marginBottom: "12px",
        background: "#f5f7fa",
        border: "0.5px solid #e0e0e0",
        borderRadius: "6px",
        boxSizing: "border-box",
      }}
    >
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          WorkStage Name<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          disabled
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.name}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          InputType<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          disabled
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.workstage_inputtype}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Percentage<span className="required">*</span>
        </label>
        <input
          type="number"
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          placeholder="Enter Percentage"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") e.preventDefault();
          }}
          value={stage.percentage}
          onChange={(e) => handlePercentageChange(index, e.target.value)}
        />
        {errors[`percentage_${index}`] && (
          <span className="error-message font-size-text">{errors[`percentage_${index}`]}</span>
        )}
        {errors.totalPercentage && (
          <span className="error-message font-size-text">{errors.totalPercentage}</span>
        )}
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Cost<span className="required">(RO)</span>
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="0"
          disabled
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.cost}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Scope
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter Scope"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.scope}
          onChange={(e) => {
            const updated = [...formData.workstat];
            updated[index].scope = e.target.value;
            setFormData((prev) => ({ ...prev, workstat: updated }));
          }}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Actual
        </label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter actual"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={stage.actual}
          onChange={(e) => {
            const updated = [...formData.workstat];
            updated[index].actual = e.target.value;
            setFormData((prev) => ({ ...prev, workstat: updated }));
          }}
        />
      </div>

      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading" style={{ whiteSpace: "nowrap" }}>
          Duration (Days)<span className="required">*</span>
        </label>
        <input
          type="number"
          className="form-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          placeholder="e.g. 45"
          min={0}
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") e.preventDefault();
          }}
          value={stage.duration_days ?? ""}
          onChange={(e) => handleDurationChange(index, e.target.value)}
        />
        {errors[`duration_${index}`] && (
          <span className="error-message font-size-text">{errors[`duration_${index}`]}</span>
        )}
      </div>
    </div>
  ))}
            </div>

            {/* Submit Button */}
            <div className="button-models" style={{ width: "100%" }}>
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="model-button font-weight500 model-button-submit"
              >
                Update
              </button>
            </div>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteProject = ({ i, getProject }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(`${BASE_URL}/dpr/project/${i.id}/`, AUTH());

      if (res.status === 200) {
        toast.success(`Data deleted successfully`);
        await getProject(); // refresh table
        setShow(false);
      }
    } catch (err) {
      toast.error("Failed to delete data");
      console.error(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Project Name"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Section: {i.section_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete <strong>{i.pr_code}</strong>?
          </p>
          <div className="button-models">
            <button
              className="model-button model-button-cancel"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-delete"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { AddProjectDetails, UpdateProjectDetails, DeleteProject };